import { useState } from 'react';

const faqs = [
  {
    q: 'Was ist das OOPBuy Spreadsheet?',
    a: 'Das OOPBuy Spreadsheet ist ein umfassendes Tool, das Dir hilft, die besten Produkte aus verschiedenen Kategorien wie Schuhe, Hoodies, T-Shirts und mehr zu finden. Es enthält geprüfte Verkäufer, QC-Informationen und Vergleichstabellen speziell für den deutschen Markt.',
  },
  {
    q: 'Wie funktioniert das OOPBuy Spreadsheet?',
    a: 'Das Spreadsheet ist in verschiedene Kategorien unterteilt. Du kannst nach Produkttyp, Verkäufer oder Preis filtern. Jeder Eintrag enthält detaillierte Informationen zu Qualität, Versand und Bewertungen. Neue Produkte werden regelmäßig hinzugefügt.',
  },
  {
    q: 'Ist das OOPBuy Spreadsheet kostenlos?',
    a: 'Ja, das OOPBuy Spreadsheet ist komplett kostenlos nutzbar. Wir aktualisieren die Daten regelmäßig, um Dir stets die aktuellsten Informationen zu bieten. Besuche einfach unsere Hauptseite für den vollen Zugriff.',
  },
  {
    q: 'Welche Kategorien gibt es im OOPBuy Spreadsheet?',
    a: 'Unser Spreadsheet deckt 14 Kategorien ab: Schuhe, Hoodies & Pullover, T-Shirts, Jacken, Hosen & Shorts, Kopfbedeckung, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfums und Sonstiges. Jede Kategorie wird sorgfältig gepflegt.',
  },
  {
    q: 'Wie aktuell sind die Daten im OOPBuy Spreadsheet?',
    a: 'Die Daten werden wöchentlich aktualisiert. Neue Verkäufer und Produkte werden nach gründlicher QC-Prüfung hinzugefügt. Veraltete Einträge werden regelmäßig entfernt, um die Qualität des Spreadsheets zu gewährleisten.',
  },
  {
    q: 'Kann ich das OOPBuy Spreadsheet auch in Österreich und der Schweiz nutzen?',
    a: 'Absolut! Das OOPBuy Spreadsheet ist für den gesamten DACH-Raum optimiert. Die Versandinformationen und Preise sind auf Deutschland, Österreich und die Schweiz abgestimmt.',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Häufige Fragen
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            Alles was Du über das OOPBuy Spreadsheet wissen musst
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white rounded-2xl overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</span>
                <div className={`w-8 h-8 rounded-full bg-background-100 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-96 pb-5 md:pb-6 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}